import { render } from "./ChulhaDay.vue?vue&type=template&id=0ede2fc0&scoped=true"
import script from "./ChulhaDay.vue?vue&type=script&lang=js"
export * from "./ChulhaDay.vue?vue&type=script&lang=js"

import "./ChulhaDay.vue?vue&type=style&index=0&id=0ede2fc0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0ede2fc0"

export default script